import React from "react";

interface ImageStripProps {
    src: string | undefined;
    height?: string | number; // visible strip height
}

const ImageStrip: React.FC<ImageStripProps> = ({ src, height = "250px" }) => {
    return (
        <div
            style={{
                width: "100%",
                height: typeof height === "number" ? `${height}px` : height,
                overflow: "hidden",
                position: "relative",
            }}
        >
            <img
                src={src}
                alt=""
                style={{
                    width: "100%",
                    position: "absolute",
                    top: "50%",
                    left: "50%",
                    transform: "translate(-50%, -50%)",
                }}
            />
        </div>
    );
};

export default ImageStrip;
